import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import type { WeakSpot } from "../lib/coach-plan.js";

export function WeakSpotCard({
  spot,
  period = "7 days",
}: {
  spot: WeakSpot;
  period?: string;
}): ReactNode {
  const pct = Math.round(spot.lapseRate * 100);
  const barWidth = `${Math.min(100, pct)}%`;
  const drillUrl = spot.drillRoute.replace("mode=listen", "mode=practice");

  return (
    <div className="border border-ink/10 p-4">
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-accent mb-1">
        needs work · {spot.node.track}
      </p>
      <p className="font-serif text-[20px] font-medium text-ink mb-2 leading-snug">
        {spot.node.title}
      </p>

      <div className="h-1 bg-ink/10 mb-1" aria-hidden="true">
        <div className="h-full bg-accent" style={{ width: barWidth }} />
      </div>
      <div className="flex justify-between items-center mb-3">
        <span className="font-mono text-[10px] text-accent">{pct}% lapse</span>
        <span className="font-mono text-[10px] text-inkFaded">{period}</span>
      </div>

      <Link
        to={drillUrl}
        className="font-mono text-[10px] uppercase tracking-widest text-ink hover:text-accent transition-colors"
      >
        ↳ Drill this →
      </Link>
    </div>
  );
}
